import { Controller } from "@hotwired/stimulus"

// Functions like tabs, but with only 2 states

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ['switch', 'offState', 'onState']

  static values = {
    state: { type: Number, default: 0 }
  }

  static classes = [
    'switchOff',
    'switchOn',
    'contentHidden',
    'contentActive'
  ]

  connect() {}

  offStateTargetConnected() {
    this.displayCurrentState()
  }

  stateValueChanged() { this.displayCurrentState() }

  displayCurrentState() {
    if (this.stateValue === 0) {
      this.showOffState()
    } else {
      this.showOnState()
    }
  }

  // Changing the stateValue triggers change via stateValueChanged callback
  switch() {
    if (this.stateValue === 0) {
      this.stateValue = 1
    } else {
      this.stateValue = 0
    }
  }

  showOffState() {
    this.onStateTarget.classList.remove(...this.contentActiveClasses)
    this.onStateTarget.classList.add(...this.contentHiddenClasses)
    this.offStateTarget.classList.remove(...this.contentHiddenClasses)
    this.offStateTarget.classList.add(...this.contentActiveClasses)

    this.switchTarget.classList.remove(...this.switchOnClasses)
    this.switchTarget.classList.add(...this.switchOffClasses)
  }

  showOnState() {
    this.offStateTarget.classList.remove(...this.contentActiveClasses)
    this.offStateTarget.classList.add(...this.contentHiddenClasses)
    this.onStateTarget.classList.remove(...this.contentHiddenClasses)
    this.onStateTarget.classList.add(...this.contentActiveClasses)

    this.switchTarget.classList.remove(...this.switchOffClasses)
    this.switchTarget.classList.add(...this.switchOnClasses)
  }
}
